import useAdminData from "hooks/useAdminData";
import { createContext } from "react";

export const AuthContext = createContext({
    isLoading: true,
    adminProfile: null,
    setAdmin(profile) { console.log(profile); },
    logout() { console.log("logout") },
    refetch() { console.log("logout") }
})

export default function AuthContextProvider({ children }) {

    const {
        userProfile:adminProfile,
        isLoading,
        setUserProfile:setAdmin,
        refetch
    } = useAdminData()

    return (
        <AuthContext.Provider value={{ setAdmin,adminProfile,isLoading,refetch }}>
            {children}
        </AuthContext.Provider>
    )
}